<template>
  <div class="row">
    <div class="col-12">
      <div class="row d-flex justify-content-center">
        <div class="col-6 mt-2">
          <el-card
            shadow="always"
            class="p-0"
            style="border-radius: 10px"
            v-loading="loading"
          >
            <div class="row pb-4">
              <div class="col-12">
                <h2
                  class="text-navy text-uppercase mb-2 font-weight-bold text-center"
                >
                  ID Verification: {{ idenfySession.status }}
                </h2>
              </div>
            </div>
            <div class="row" v-if="idenfySession.status === 'active'">
              <div class="col-12 text-center font-weight-bold">
                <div>Please review your details before start</div>
                <div>First Name: {{ idenfySession.first_name }}</div>
                <div>Last Name: {{ idenfySession.last_name }}</div>
              </div>
              <div class="col-12 text-center mt-2">
                Once you start the ID verification process, you will be
                redirected to the ID verification page
              </div>

              <div class="col-12 text-center pt-4">
                <a
                  :href="idenfySession.verification_url"
                  class="btn-primary px-3"
                >
                  Start ID Verification
                </a>
              </div>
            </div>
            <div class="row" v-else-if="idenfySession.status === 'pending'">
              <div class="col-12 text-center py-2">
                <p class="font-weight-bold">ID Verification is pending.</p>
                <p>
                  The verification process is pending, please contact our
                  support team for further assistance.
                </p>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-12 text-center py-2">
                <p class="font-weight-bold">ID Verification was completed.</p>
                <p>
                  If the verification was unsuccessful, please contact our
                  support team for further assistance.
                </p>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    initial_idenfy_session: {
      type: Object,
    },
  },

  data() {
    return {
      idenfySession: this.initial_idenfy_session,
    };
  },
  mounted() {},
  methods: {},
};
</script>
